import React, { useEffect } from 'react';
import { defineNextPage } from '@/common/next';
import Head from 'next/head';
import { message } from '$/components/Message';
import { getIpResolution, getSoraStatus } from '$/api/canvasRquest';
import { openVipModal, type OpenMode } from '$/store/useVipModalStore';
import IPadTips from '@/components/IPadTips';
import { useCommonStore } from '@/store/useCommonStore';
import { setHomeVersionCookie } from '@/common/homeVersionCookie';
import { useOfficialStore } from '$/store/useOfficialStore';
import HomeSubscribeActivityBanner from '../components/HomeSubscribeActivityBanner';
import HomePopups from './components/HomePopups';
import styles from './index.module.scss';
import BaseHome from './components/BaseHomeNew';

/**
 * 渲染 RoboNeo 首页页面容器，并挂载首页级引导条与弹窗入口。
 */
function Content() {
  const initialized = useCommonStore((state) => state.initialized);
  const isOnline = useCommonStore((state) => state.isOnline);
  const isUserLoggedIn = useOfficialStore((state) => state.isUserLoggedIn());

  // 实际进入新版首页后再记录版本，避免只点击切换但跳转失败时污染首页记忆。
  useEffect(() => {
    setHomeVersionCookie('new');
  }, []);

  useEffect(() => {
    if (!isOnline) {
      message.error('RoboNeo_Web_network_fail_retry');
    }
  }, [isOnline]);

  // 检测 sessionStorage，如果有 openVip 则打开 VipModal
  useEffect(() => {
    if (initialized && isUserLoggedIn) {
      const openVipSource = sessionStorage.getItem('openVip');
      if (openVipSource) {
        openVipModal?.(openVipSource as OpenMode);
        // 清除 sessionStorage，避免刷新页面时再次打开
        sessionStorage.removeItem('openVip');
      }
    }
  }, [initialized, isUserLoggedIn]);

  useEffect(() => {
    if (initialized) {
      window.mtstat?.track('home_page_exp', {
        is_login: isUserLoggedIn ? 1 : 0,
      });
      window.mtstat?.track('home_page_enter', {
        is_login: isUserLoggedIn ? 1 : 0,
        current_version: 'new',
      });
    }
  }, [initialized, isUserLoggedIn]);

  /**
   * 首页业务侧处理 home_tags 曝光，避免放入通用输入 hook。
   */
  useEffect(() => {
    if (!initialized) return;
    getSoraStatus().then((res) => {
      if (!res?.home_tags?.length) return;
      const text = res.home_tags.map((tag) => tag.name).join(',');
      const id = res.home_tags.map((tag) => tag.id).join(',');
      window.mtstat?.track('roboneo_callword_cexp', { text, id });
    }).catch(() => {});
  }, [initialized]);

  // 客户端 IP 解析日志
  useEffect(() => {
    if (initialized) {
      getIpResolution()
        .then((data) => {
          console.log('[Home] IP 解析结果:', data);
        })
        .catch((err) => {
          console.warn('[Home] IP 解析请求失败:', err);
        });
    }
  }, [initialized]);

  return (
    <>
      <HomeSubscribeActivityBanner />
      <div className={styles.mainBox}>

        {/* 内容区域 */}
        <BaseHome />
      </div>
      {/* ipad 提示 */}
      <IPadTips />

      {/* 统一处理首页弹窗 */}
      <HomePopups />
    </>
  );
}
export default defineNextPage<{
  title: string;
}>({
  pageConfig: {
    projectId: '/--roboneo',
    layoutId: 'RoboneoLayout',
    /** 在服务端为 /home 输出稳定的自引用 canonical，避免内部路由或参数地址被重复收录。 */
    renderHead({ pageProps }) {
      return (
        <Head>
          <title>RoboNeo</title>
          <link key="canonical" rel="canonical" href="https://www.roboneo.com/home" />
        </Head>
      );
    },
  },
  component: () => {
    return <Content />;
  },
});
